import APIController from '../core-api-controller';

export const fetchRecommendedProductVariantsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/recommendations${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUserRecommendedProductVariantsApi = (productId = '') => {
  const path = `${APIController.endpointApi}/client_user/product_variants/${productId}/recommendations`;
  return APIController.getApiCallback(path);
};

export const fetchProductVariantApi = (id) => {
  const path = `${APIController.endpointApi}/product_variants/${id}`;
  return APIController.getApiCallback(path);
};

export const editProductVariantsApi = (variantId = '', data = {}, signal = null) => {
  const path = `${APIController.endpointApi}/product_variants/${variantId}`;
  return APIController.putCallback(path, data, null, signal);
};

export const updateProductVariantsApi = (id = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/product_variants/${id}`;
  return APIController.putCallback(path, paramsObj);
};

export const addProductVariantsApi = (data = {}) => {
  const path = `${APIController.endpointApi}/product_variants`;
  return APIController.postCallback(path, data);
};

export const calculateProductVariantsDiscountApi = (paramsStr = {}) => {
  const path = `${APIController.endpointApi}/client_user/product_variants/calculate_discounts${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const fetchPendingTransactionsApi = (userId = '') => {
  const path = `${APIController.endpointApi}/client_user/users/${userId}/fetch_pending_transaction`;
  return APIController.getApiCallback(path);
};

export const cancelPendingTransactionsApi = (userId = '') => {
  const path = `${APIController.endpointApi}/client_user/users/${userId}/cancel_pending_transactions`;
  return APIController.postCallback(path);
};
